import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")
  const _component_van_tabbar = _resolveComponent("van-tabbar")

  return (_openBlock(), _createBlock(_component_van_tabbar, {
    modelValue: $options.active,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($options.active) = $event))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_van_tabbar_item, {
        replace: "",
        to: "/page/index",
        icon: "home-o"
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 首页 ")
        ]),
        _: 1
      }),
      _createVNode(_component_van_tabbar_item, {
        replace: "",
        to: "/page/product",
        icon: "list-switch"
      }, {
        default: _withCtx(() => [
          _createTextVNode("产品")
        ]),
        _: 1
      }),
      _createVNode(_component_van_tabbar_item, {
        replace: "",
        to: "/page/mine",
        icon: "friends-o"
      }, {
        default: _withCtx(() => [
          _createTextVNode("我的")
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}